import React from "react";
import Loading from "./Loading";

const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100 position-fixed inset-0 z-100" style={{background: "#0042A400033", zIndex: 99, right: 0, top: 0,  maxWidth: "calc(100% - 250px)"}}>
      <Loading />
    </div>
  );
};

export default Loader;
